// Corporate Rating - Adapted for corporate users with corporate user data
import React from 'react';
import StandardRating from '../../Rating/Rating';

/**
 * Corporate Rating Component
 * Uses corporate user data when REACT_APP_CORPORATE_MODE is enabled
 */
const CorporateRating = () => {
    // For now, uses the standard component
    // Can be customized to use corporate-specific queries and data
    return <StandardRating />;
};

export { CorporateRating as Rating };
